import { LazyPage } from '../../components/loadable';

export const AccountProcessWrapper = LazyPage(import('./account_process_wrapper'));